
function Elements()
{
    let elements = {
        phone: document.getElementById('reg-phone'),
        subname: document.getElementById('reg-subname'),
        name: document.getElementById('reg-name'),
        patronymic: document.getElementById('reg-patronymic'),
        codeCountry: document.getElementById('reg-select'),
        email: document.getElementById('reg-email'),
        city: document.getElementById('reg-city'),
        check: document.getElementById('reg-check'),
        notFilledPhone: document.querySelector('.phone'),
        notFilledSubname: document.querySelector('.subname'),
        notFilledName: document.querySelector('.name'),
        notFilledPatranomic: document.querySelector('.patronymic'),
        notFilledCodeCountry: document.querySelector('.codeCountry'),
        notFilledEmail: document.querySelector('.email'),
        notFilledCity: document.querySelector('.city'),
        notFilledCheck: document.querySelector('.check')
    }
    return elements
}
function FreeElements()
{
    let elements = {
        phone: document.getElementById('free-phone'),
        subname: document.getElementById('free-subname'),
        name: document.getElementById('free-name'),
        patronymic: document.getElementById('free-patronymic'),
        codeCountry: document.getElementById('free-select'),
        email: document.getElementById('free-email'),
        city: document.getElementById('free-city'),
        check: document.getElementById('free-check'),
        notFilledPhone: document.querySelector('.freePhone'),
        notFilledSubname: document.querySelector('.freeSubname'),
        notFilledName: document.querySelector('.freeName'),
        notFilledPatranomic: document.querySelector('.freePatronymic'),
        notFilledCodeCountry: document.querySelector('.freeCodeCountry'),
        notFilledEmail: document.querySelector('.freeEmail'),
        notFilledCity: document.querySelector('.freeCity'),
        notFilledCheck: document.querySelector('.freeCheck')
    }
    return elements
}
function PayElements()
{
    let elements = {
        phone: document.getElementById('pay-phone'),
        subname: document.getElementById('pay-subname'),
        name: document.getElementById('pay-name'),
        patronymic: document.getElementById('pay-patronymic'),
        codeCountry: document.getElementById('pay-select'),
        email: document.getElementById('pay-email'),
        city: document.getElementById('pay-city'),
        check: document.getElementById('pay-check'),
        notFilledPhone: document.querySelector('.payPhone'),
        notFilledSubname: document.querySelector('.paySubname'),
        notFilledName: document.querySelector('.payName'),
        notFilledPatranomic: document.querySelector('.payPatronymic'),
        notFilledCodeCountry: document.querySelector('.payCodeCountry'),
        notFilledEmail: document.querySelector('.payEmail'),
        notFilledCity: document.querySelector('.payCity'),
        notFilledCheck: document.querySelector('.payCheck')
    }
    return elements
}
$('#pills-profile-tab').on("click", function(event){

    event.preventDefault();

    if(notFilled(PayElements().name, PayElements().notFilledName)
        && notFilled(PayElements().subname, PayElements().notFilledSubname)
        && validPhone(PayElements().phone, PayElements().notFilledPhone)
        && notFilled(PayElements().patronymic, PayElements().notFilledPatranomic)
        && notFilled(PayElements().codeCountry, PayElements().notFilledCodeCountry)
        && validEmail(PayElements().email, PayElements().notFilledEmail)
        && notFilled(PayElements().city, PayElements().notFilledCity)
        && PayElements().check.checked )
    {
        $('.not-filled').removeClass('not-filled');
        $('.not-valid').removeClass('not-valid');
        document.getElementById('pills-profile-tab').style.display = 'none';
        document.getElementById('pills-home-tab').style.display = 'block';

    }else{
        $('.not-filled').removeClass('not-filled');
        $('.not-valid').removeClass('not-valid');
        $('.line-error-email').removeClass('line-error-email');
        validPhone(PayElements().phone, PayElements().notFilledPhone)
        notFilled(PayElements().name, PayElements().notFilledName)
        notFilled(PayElements().subname, PayElements().notFilledSubname)
        notFilled(PayElements().patronymic, PayElements().notFilledPatranomic)
        notFilled(PayElements().codeCountry, PayElements().notFilledCodeCountry)
        validEmail(PayElements().email, PayElements().notFilledEmail)
        notFilled(PayElements().city, PayElements().notFilledCity)
        if(!PayElements().check.checked){
            PayElements().notFilledCheck.classList.add("not-filled");
        }
        return false;
    }

});
$('#button-free-program').on("click", function(event){
    $('.not-filled').removeClass('not-filled');
    $('.not-valid').removeClass('not-valid');
    notFilled(FreeElements().subname, FreeElements().notFilledSubname)
    notFilled(FreeElements().name, FreeElements().notFilledName)
    notFilled(FreeElements().patronymic, FreeElements().notFilledPatranomic)
    validPhone(FreeElements().phone, FreeElements().notFilledPhone)
    validEmail(FreeElements().email, FreeElements().notFilledEmail)
    notFilled(FreeElements().city, FreeElements().notFilledCity)
    notFilled(FreeElements().codeCountry, FreeElements().notFilledCodeCountry)
    if(!FreeElements().check.checked){
        FreeElements().notFilledCheck.classList.add("not-filled");
    }

})
$('#button-register').on('click', (event) => {
    $('.not-filled').removeClass('not-filled');
    $('.not-valid').removeClass('not-valid');
    validPhone(Elements().phone, Elements().notFilledPhone)
    notFilled(Elements().name, Elements().notFilledName)
    notFilled(Elements().subname, Elements().notFilledSubname)
    notFilled(Elements().patronymic, Elements().notFilledPatranomic)
    notFilled(Elements().codeCountry, Elements().notFilledCodeCountry)
    validEmail(Elements().email, Elements().notFilledEmail)
    notFilled(Elements().city, Elements().notFilledCity)
    if(!Elements().check.checked){
        Elements().notFilledCheck.classList.add("not-filled");
    }
})

$('#pills-login-tab').on("click", function(event){
    event.preventDefault();

    let email = document.getElementById('reg-email1')
    let password = document.getElementById('reg-password1')
    let notFilled = document.querySelectorAll('.input-block')
    if (password.value && email.value) {
        $(".not-filled").removeClass("not-filled");
        switch (checkData(email.value, password.value)) {
            case '0':
                document.getElementById("pills-login-tab").style.display = "none";
                document.getElementById("pills-logina-tab").style.display = "block";
                break;
            case '1':
                $(".notFilledEmail").css("display", "block");
                return false
            case '2':
                $(".notFilledPass").css("display", "block");
                return false
        }
    } else {
        $(".not-filled-mail").css("display", "block");
        $(".not-filled-pass").css("display", "block");
        $(".not-filled").removeClass("not-filled");
        $(".line-error-email").removeClass("line-error-email");
        if (!password.value) {
            notFilled[1].classList.add("not-filled");
        }
        if (!validateEmail(email.value) && email.value) {
            notFilled[4].classList.add("line-error-email");
        }
        return false;
    }

});

$('#check-agree').on('click', function(event) {
    let email = document.getElementById('reg-email1')
    let password = document.getElementById('reg-password1')
    let notFilled = document.querySelectorAll('.input-block')
    if (password.value && email.value) {
        $(".not-filled").removeClass("not-filled");
        switch (checkData(email.value, password.value)) {
            case '0':
                return true
            case '1':
                event.preventDefault();
                $(".notFilledEmail").css("display", "block");
                return false
            case '2':
                event.preventDefault();
                $(".notFilledPass").css("display", "block");
                return false
        }
    } else {
        $(".not-filled-mail").css("display", "block");
        $(".not-filled-pass").css("display", "block");
        $(".not-filled").removeClass("not-filled");
        $(".line-error-email").removeClass("line-error-email");
        if (!password.value) {
            notFilled[1].classList.add("not-filled");
        }
        if (!validateEmail(email.value) && email.value) {
            notFilled[4].classList.add("line-error-email");
        }
        return false;
    }
})

$("#pills-logina-tab").on('click', () => {
    $("#pills-logina-tab").css('display', 'none');
    $("#pills-login-tab").css('display', 'block');
    $("#forgot-pass").css('display', 'block');
});

$("#auth-agree").on('click', () => {
    if ($("#auth-agree").prop('checked')) {
        $("#check-agree").prop('disabled', false)
    }
    else {
        $("#check-agree").prop('disabled', true)
    }
})


$("#pills-login-tab").on('click', () => {
    $("#forgot-pass").css('display', 'none');
});

$("#pay-phone").on("click", () => {
    if ($("#pay-select").val() == "+7") {
        $("#pay-phone").attr("maxlength", "10");
    } else {
        $("#pay-phone").removeAttr("maxlength");
    }
});

$("#free-phone").on("click", () => {
    if ($("#free-select").val() == "+7") {
        $("#free-phone").attr("maxlength", "10");
    } else {
        $("#free-phone").removeAttr("maxlength");
    }
});

$("#reg-phone").on("click", () => {
    if ($("#reg-select").val() == "+7") {
        $("#reg-phone").attr("maxlength", "10");
    } else {
        $("#reg-phone").removeAttr("maxlength");
    }
});

$("#pay-phone").on("focusout", () => {
    let num = $("#pay-phone").val();
    num = num.replaceAll(/\D/g, '');
    if($("#pay-select").val() == '+7') {
        switch (num.length) {
            case 11:
                num = num.replace(/^.{1}/, "");
                break;
            case 12:
                num = num.replace(/^.{2}/, "");
                break;
        }
    }
    $("#pay-phone").val(num);
})

$("#free-phone").on('focusout', () => {
    let num = $("#free-phone").val();
    num = num.replaceAll(/\D/g, '');
    if ($("#free-select").val() == "+7") {
        switch (num.length) {
            case 11:
                num = num.replace(/^.{1}/, "");
                break;
            case 12:
                num = num.replace(/^.{2}/, "");
                break;
        }
    }
    $("#free-phone").val(num);
})

$("#reg-phone").on('focusout', () => {
    let num = $("#reg-phone").val();
    num = num.replaceAll(/\D/g, '');
    if ($("#reg-select").val() == "+7") {
        switch (num.length) {
            case 11:
                num = num.replace(/^.{1}/, "");
                break;
            case 12:
                num = num.replace(/^.{2}/, "");
                break;
        }
    }
    $("#reg-phone").val(num);
})
$('#pills-home-tab').on("click", function(event){
    event.preventDefault();

    document.getElementById('pills-home-tab').style.display = 'none';
    document.getElementById('pills-profile-tab').style.display = 'block';

});
function notFilled(attr, selector) {
    if (attr.value.length < 2) {
        event.preventDefault()
        selector.classList.add("not-filled")
        return false
    }
    return true
}
function validateEmail(email) {
    const re = /^([a-zA-Z0-9_.,\-]{2,})@([a-zA-Z0-9_-]{2,})\.([a-z-]{2,6})/i;
    return re.test(String(email).toLowerCase());
}
function validatePhone(myPhone) {
    let re = /^[0-9() +-]{10,}$/im;
    if((PayElements().codeCountry != null && PayElements().codeCountry.value != '+7') ||
        (Elements().codeCountry != null && Elements().codeCountry.value != '+7') ||
        (FreeElements().codeCountry != null && FreeElements().codeCountry.value != '+7'))
    {
        re = /^[0-9() +-]{6,}$/im;
    }

    return re.test(myPhone);
}
function validPhone(attr, selector)
{
    if (!attr.value) {
        selector.classList.add("not-filled")
        return false
    } else if(!validatePhone(attr.value)) {
        event.preventDefault()
        selector.classList.add('not-valid')
        return false;
    }
    return true
}
function validEmail(attr, selector = '')
{
    if (!attr.value) {
        selector.classList.add("not-filled")
        return false
    } else if (!validateEmail(attr.value)) {
        event.preventDefault()
        selector.classList.add('not-valid')
        return false;
    }
    else return true
}
let checkMail = '';
// open modals
$('#btn-to-register').on('click', () => {
    $('.register').fadeToggle();
    $('.question').fadeToggle();
})

$('#btn-to-auth').on('click', () => {
    $('.auth').fadeToggle();
    $('.question').fadeToggle();
})

$('#btn-forgot').on('click', () => {
    $('.mail').fadeToggle();
    $('.question').fadeToggle();
})


$("#return-back").on('click', () => {
    $('.question').fadeToggle();
    $('.mail-send').fadeToggle();
})

$('#btn-to-login').on('click', () => {
    $('.login').fadeToggle();
    $('.question').fadeToggle();
})

$('#btn-to-waitlist-register').on('click', () => {
    $('.waitlist-register').fadeToggle();
    $('.question').fadeToggle();
})

//end open modals

//close modals
$('#close-waitlist').on('click', () => {
    $('.waitlist').fadeToggle();
    $('body').removeClass('modal-open');
})

$('#close-waitlist-register').on('click', () => {
    $('.waitlist-register').fadeToggle();
    $('body').removeClass('modal-open');
})

$('#close-login').on('click', () => {
    $('.login').fadeToggle();
    $('body').removeClass('modal-open')
})

$('#close-question').on('click', () => {
    $('.question').fadeToggle();
    $('body').removeClass('modal-open');
})

$('#close-register').on('click', () => {
    $('.register').fadeToggle();
    $('body').removeClass('modal-open');
})
$('#close-terms').on('click', () => {
    $('.terms').fadeToggle();
    $('body').removeClass('modal-open')
})

$('#close-auth').on('click', () => {
    $('.auth').fadeToggle();
    $('body').removeClass('modal-open')
})

$("#close-mail").on('click', () => {
    $('.mail').fadeToggle();
    $('body').removeClass('modal-open')
})

$("#close-mail-send").on('click', () => {
    $('.mail-send').fadeToggle();
    $('body').removeClass('modal-open')
})
//end close modal

//send user data on mail for check
$("#check-mail").on('click', () => {
    checkMail = $("#check-email").val();
    if (checkMail != '')
    {
        $('.mail-send').fadeToggle();
        $('.mail').fadeToggle();
    }
    $("#check-mail-message").text(`Информация о вашем личном кабинете была отправлена вам на почту: ${checkMail}`);
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        url: "/check_account",
        type: "POST",
        data: {
            checkMail
        },
        headers: {
            'X-CSRF-TOKEN' : CSRF_TOKEN
        },
        success: (data) => {
        },
    });
})

function handleData(data) {
    return data;
}

function checkData(email, password, handleData) {
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    let result;
    $.ajax({
        url: `/check-user-data`,
        type: "POST",
        async: false,
        data: {
            email: email,
            password: password,
        },
        headers: {
            "X-CSRF-TOKEN": CSRF_TOKEN,
        },
        success: (data) => {
            result = data;
        },
    });
    return result;
}
